import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Component({
  selector: 'app-iframe-maximizer',
  templateUrl: './iframe-maximizer.component.html',
  styleUrls: ['./iframe-maximizer.component.scss']
})
export class IframeMaximizerComponent {
  @Input() src: string;
  @Input() hideButtonWhenMinimized = false;

  @Output() maximized = new EventEmitter<void>();
  @Output() minimized = new EventEmitter<void>();

  isMaximized = false;
  private historyStatePushed = false;

  @HostListener('window:popstate', ['$event'])
  onPopState(event: PopStateEvent): void {
    if (this.isMaximized) {
      this.minimize(true);
    }
  }

  toggleMaximize(): void {
    if (this.isMaximized) {
      this.minimize();
    } else {
      this.maximize();
    }
  }

  maximize(): void {
    this.isMaximized = true;
    document.body.style.overflow = 'hidden';

    if (!this.historyStatePushed) {
      window.history.pushState({ iframeMaximized: true }, '');
      this.historyStatePushed = true;
    }
    this.maximized.emit();
  }

  minimize(fromPopState = false): void {
    if (this.isMaximized) {
      this.isMaximized = false;
      document.body.style.overflow = 'auto';
      // Se a minimização não for proveniente do popstate, retorna no histórico (removendo o estado empurrado)
      if (!fromPopState && this.historyStatePushed) {
        window.history.back();
        this.historyStatePushed = false;
      } else {
        this.historyStatePushed = false;
      }
      this.minimized.emit();
    }
  }
}
